(function($) {
  'use strict';

  if (!$) return;

  $(document).off('variant:changed.oukitelPrice').on('variant:changed.oukitelPrice', function(evt) {
    var variant = evt.currentVariant;
    var onSale = variant && variant.compare_at_price > 0 && variant.compare_at_price > variant.price;

    $(evt.target).find('[data-main-discount-badge]').each(function() {
      this.hidden = !onSale;
      if (onSale) {
        var percent = Math.max(1, Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price));
        $(this).find('[data-discount-percent]').text(percent);
      }
    });
  });
})(window.jQuery_T4NT);
